/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CostOnJobsDtoBaseResponse } from '../models/cost-on-jobs-dto-base-response';
import { FreelanceDtoBaseResponse } from '../models/freelance-dto-base-response';
import { OutOfHoursDtoBaseResponse } from '../models/out-of-hours-dto-base-response';

@Injectable({
  providedIn: 'root',
})
export class ReportService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiReportCostOnJobsGet
   */
  static readonly ApiReportCostOnJobsGetPath = '/api/Report/cost-on-jobs';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiReportCostOnJobsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiReportCostOnJobsGet$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<CostOnJobsDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ReportService.ApiReportCostOnJobsGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CostOnJobsDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiReportCostOnJobsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiReportCostOnJobsGet$Plain(params?: {
  }): Observable<CostOnJobsDtoBaseResponse> {

    return this.apiReportCostOnJobsGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<CostOnJobsDtoBaseResponse>) => r.body as CostOnJobsDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiReportCostOnJobsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiReportCostOnJobsGet$Json$Response(params?: {
  }): Observable<StrictHttpResponse<CostOnJobsDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ReportService.ApiReportCostOnJobsGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CostOnJobsDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiReportCostOnJobsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiReportCostOnJobsGet$Json(params?: {
  }): Observable<CostOnJobsDtoBaseResponse> {

    return this.apiReportCostOnJobsGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<CostOnJobsDtoBaseResponse>) => r.body as CostOnJobsDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiReportFreelanceGet
   */
  static readonly ApiReportFreelanceGetPath = '/api/Report/freelance';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiReportFreelanceGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiReportFreelanceGet$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<FreelanceDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ReportService.ApiReportFreelanceGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FreelanceDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiReportFreelanceGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiReportFreelanceGet$Plain(params?: {
  }): Observable<FreelanceDtoBaseResponse> {

    return this.apiReportFreelanceGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<FreelanceDtoBaseResponse>) => r.body as FreelanceDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiReportFreelanceGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiReportFreelanceGet$Json$Response(params?: {
  }): Observable<StrictHttpResponse<FreelanceDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ReportService.ApiReportFreelanceGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FreelanceDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiReportFreelanceGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiReportFreelanceGet$Json(params?: {
  }): Observable<FreelanceDtoBaseResponse> {

    return this.apiReportFreelanceGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<FreelanceDtoBaseResponse>) => r.body as FreelanceDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiReportOutOfHoursGet
   */
  static readonly ApiReportOutOfHoursGetPath = '/api/Report/out-of-hours';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiReportOutOfHoursGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiReportOutOfHoursGet$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<OutOfHoursDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ReportService.ApiReportOutOfHoursGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OutOfHoursDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiReportOutOfHoursGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiReportOutOfHoursGet$Plain(params?: {
  }): Observable<OutOfHoursDtoBaseResponse> {

    return this.apiReportOutOfHoursGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<OutOfHoursDtoBaseResponse>) => r.body as OutOfHoursDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiReportOutOfHoursGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiReportOutOfHoursGet$Json$Response(params?: {
  }): Observable<StrictHttpResponse<OutOfHoursDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ReportService.ApiReportOutOfHoursGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OutOfHoursDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiReportOutOfHoursGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiReportOutOfHoursGet$Json(params?: {
  }): Observable<OutOfHoursDtoBaseResponse> {

    return this.apiReportOutOfHoursGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<OutOfHoursDtoBaseResponse>) => r.body as OutOfHoursDtoBaseResponse)
    );
  }

}
